module.exports = "https://img.zhijierongxing.com/saas/img/rmb_icon.7b041e32.png";